export default __webpack_public_path__ + "static/media/covid19.56cb27f1.png";